import React from 'react';

const ShineEffect: React.FC = () => {
  return (
    <>
      {/* Shine Effect */}
      <div 
        className="absolute inset-0 transition-transform duration-1000 group-hover:translate-x-full"
        style={{
          backgroundImage: `linear-gradient(120deg, 
            rgba(255,255,255,0) 0%,
            rgba(255,255,255,0.2) 25%,
            rgba(255,255,255,0) 50%
          )`,
          backgroundSize: '200% 200%'
        }}
      />
    </>
  );
};

export default ShineEffect; 